export default "__VITE_ASSET__WkRX4Nvd__"